import StatusPill from 'components/StatusPill';
import { BatchFileType, useHistoryBatch } from 'contexts/HistoryBatch';
import { StatusFile } from 'models/statusFile';
import React, { useEffect } from 'react';

const HistoryRow = () => {
  const { selectedFile, setFile, batchFiles } = useHistoryBatch();

  useEffect(() => {
    if (batchFiles?.length && !selectedFile) {
      setFile(batchFiles[0]);
    }
  }, [batchFiles, setFile]);

  if (!batchFiles?.length) return null;

  const getClassNames = (file: BatchFileType) => {
    const isSelected = selectedFile?.id === file.id;

    if (file.status === StatusFile.PARTIAL_PROCESSED || file.status === StatusFile.ERROR) {
      return `inactive ${isSelected ? 'selected' : ''}`;
    }

    if (file.status === StatusFile.PROCESSING) {
      return `processing ${isSelected ? 'selected' : ''}`;
    }

    return `${isSelected ? 'selected' : ''}`;
  };

  return (
    <>
      {batchFiles.map((file, index) => {
        const createdDateBeneficiary = new Date(file.created).toLocaleDateString('pt-br');

        return (
          <tr
            className={`table-beneficiaries-rows ${getClassNames(file)}`}
            key={file.id}
            data-testid={`file-${index}`}
            onClick={() => setFile(file)}
          >
            <td>{createdDateBeneficiary}</td>
            <td>
              <span className="table-span">{file.filename}</span>
            </td>
            <td>
              <StatusPill selected={file.id === selectedFile?.id} status={file.status} />
            </td>
            <td className="chevron" />
          </tr>
        );
      })}
    </>
  );
};

export default HistoryRow;
